<div class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
  <div class="mb-2.5 inline-flex items-center gap-1.5 text-lg font-semibold text-neutral-900 dark:text-white">
    pagamentos
  </div>

  @for (p of payments; track $index) {
    <button
      type="button"
      (click)="copyPayment(p)"
      [title]="'Copiar ' + p.methodLabel + ' ' + formatCents(p.value)"
      class="flex w-full cursor-pointer items-center justify-between border-b border-dashed border-neutral-200 bg-transparent py-1.5 text-left last:border-b-0 focus-visible:outline-none dark:border-neutral-700"
    >
      <div class="text-sm text-neutral-900 dark:text-neutral-100">{{ p.methodLabel }}</div>
      <div class="font-mono text-sm font-bold tabular-nums text-neutral-900 dark:text-neutral-100">{{ formatCents(p.value) }}</div>
    </button>
  } @empty {
    <div class="text-sm text-neutral-500 dark:text-neutral-400">Aguardando pagamento</div>
  }
</div>
